// Site-occupancy predicate for per-target conditional follow-ups
// (Fade). Pure. Callers pass an iterable of meshes + a cellAt
// resolver, matching the locations.js / scope.js convention.
//
// ── Sorcery rule (Fade) ──
// "Give an allied minion Stealth. If it occupies an enemy site, draw a
// card." A site's controller is the player whose edge it faces
// (`rotated`); a minion occupies that site when they share a cell. The
// site is an ENEMY site when its controller differs from the minion's.

/**
 * Return the Site cardInstance occupying `cell`, or null. Mirrors
 * cellsWithSites' membership test but returns the card so the caller
 * can read its controller. `rubbleCounts: false` (default) skips
 * Rubble tiles, which are inert and controllerless.
 */
export function siteAtCell(meshes, cellAt, cell, { rubbleCounts = false } = {}) {
  if (!cell) return null;
  for (const [, mesh] of meshes) {
    const card = mesh?.userData?.cardInstance;
    if (!card?.isSite) continue;
    if (!rubbleCounts && card.cardId === 'sorcery-rubble') continue;
    const c = cellAt(mesh.position.x, mesh.position.z);
    if (c && c.col === cell.col && c.row === cell.row) return card;
  }
  return null;
}

/**
 * Does `unit` (a minion instance with a known cell) occupy a site
 * controlled by its opponent? False when the unit is on a void cell,
 * on Rubble, or on its own / allied site.
 */
export function isOnEnemySite(unit, unitCell, meshes, cellAt) {
  if (!unit || !unitCell) return false;
  const site = siteAtCell(meshes, cellAt, unitCell);
  if (!site) return false;
  return !!site.rotated !== !!unit.rotated;
}
